module.exports = __webpack_public_path__ + "media/images/career_camp/2022/intro_left_character-f52370268e0208d95fd3fcd2d4daf09c.svg";